import merge from 'deepmerge';
import isEqual from 'lodash/isEqual.js';
// a shared apollo client instance
let _client;
// variant of https://github.com/vercel/next.js/blob/canary/examples/with-apollo/lib/apolloClient.js#L42
/**
 * Get a new or cached apollo client and restore its cache if provided
 * @param initialState - initial cache state
 * @param factory  - client factory to use to create client when needed
 */
export function initApolloClient(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
initialState, factory, options) {
    const client = _client || factory.createClient(options);
    // If your page has Next.js data fetching methods that use Apollo Client, the initial state
    // gets hydrated here
    if (initialState) {
        // Get existing cache, loaded during client side data fetching
        const existingCache = client.extract();
        // Merge the existing cache into data passed from getStaticProps/getServerSideProps
        const data = merge(initialState, existingCache, {
            // combine arrays using object equality (like in sets)
            arrayMerge: (destinationArray, sourceArray) => [
                ...sourceArray,
                ...destinationArray.filter(d => sourceArray.every(s => !isEqual(d, s)))
            ]
        });
        // Restore the cache with the merged data
        client.cache.restore(data);
    }
    // For SSG and SSR always create a new Apollo Client
    if (typeof window === 'undefined')
        return client;
    // Create the Apollo Client once in the browser
    if (!_client)
        _client = client;
    return _client;
}
//# sourceMappingURL=initApolloClient.js.map